import * as i0 from '@angular/core';
import { Injectable, Component, EventEmitter, Input, Output, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i2 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i3 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import * as i1$1 from 'ngx-toastr';
import * as i1$2 from '@angular/common/http';
import { HttpParams, HttpHeaders, HttpResponse } from '@angular/common/http';
import { throwError, Subject, Observable } from 'rxjs';
import { catchError, tap, filter } from 'rxjs/operators';
import * as i2$1 from '@angular/router';

class SrhkCoreLibraryService {
    constructor() { }
}
SrhkCoreLibraryService.ɵfac = function SrhkCoreLibraryService_Factory(t) { return new (t || SrhkCoreLibraryService)(); };
SrhkCoreLibraryService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SrhkCoreLibraryService, factory: SrhkCoreLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SrhkCoreLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class SrhkCoreLibraryComponent {
}
SrhkCoreLibraryComponent.ɵfac = function SrhkCoreLibraryComponent_Factory(t) { return new (t || SrhkCoreLibraryComponent)(); };
SrhkCoreLibraryComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SrhkCoreLibraryComponent, selectors: [["lib-srhk-core-library"]], decls: 2, vars: 0, template: function SrhkCoreLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "p");
        i0.ɵɵtext(1, " srhk-core-library works! ");
        i0.ɵɵelementEnd();
    } }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SrhkCoreLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'lib-srhk-core-library',
                template: `
    <p>
      srhk-core-library works!
    </p>
  `,
                styles: []
            }]
    }], null, null); })();

function ButtonComponent_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function ButtonComponent_button_1_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.disabled ? $event.stopPropagation() : ctx_r10.loading ? $event.stopPropagation() : ctx_r10.onButtonClick(); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("spinner", ctx_r0.loading);
    i0.ɵɵproperty("id", !ctx_r0.loading ? "primary" : "")("disabled", ctx_r0.loading ? ctx_r0.loading : ctx_r0.disabled);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.label);
} }
function ButtonComponent_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function ButtonComponent_button_2_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.disabled ? $event.stopPropagation() : ctx_r12.loading ? $event.stopPropagation() : ctx_r12.onButtonClick(); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("spinner", ctx_r1.loading);
    i0.ɵɵproperty("id", !ctx_r1.loading ? "secondary" : "")("disabled", ctx_r1.loading ? ctx_r1.loading : ctx_r1.disabled);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.label);
} }
function ButtonComponent_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function ButtonComponent_button_3_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.disabled ? $event.stopPropagation() : ctx_r14.loading ? $event.stopPropagation() : ctx_r14.onButtonClick(); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("spinner", ctx_r2.loading);
    i0.ɵɵproperty("id", !ctx_r2.disabled ? "primary" : "")("disabled", ctx_r2.disabled);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r2.label);
} }
function ButtonComponent_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function ButtonComponent_button_4_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(); return ctx_r16.disabled ? $event.stopPropagation() : ctx_r16.loading ? $event.stopPropagation() : ctx_r16.onButtonClick(); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("spinner", ctx_r3.loading);
    i0.ɵɵproperty("disabled", ctx_r3.loading ? ctx_r3.loading : ctx_r3.disabled);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r3.label);
} }
function ButtonComponent_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function ButtonComponent_button_5_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(); return ctx_r18.disabled ? $event.stopPropagation() : ctx_r18.loading ? $event.stopPropagation() : ctx_r18.onButtonClick(); });
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "mat-icon", 10);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("spinner", ctx_r4.loading);
    i0.ɵɵproperty("id", !ctx_r4.loading ? "primary" : "")("disabled", ctx_r4.loading ? ctx_r4.loading : ctx_r4.disabled);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r4.iconRight && ctx_r4.label, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r4.iconName);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.iconLeft && ctx_r4.label, "");
} }
function ButtonComponent_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 11);
    i0.ɵɵlistener("click", function ButtonComponent_button_6_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(); return ctx_r20.disabled ? $event.stopPropagation() : ctx_r20.loading ? $event.stopPropagation() : ctx_r20.onButtonClick(); });
    i0.ɵɵelementStart(1, "mat-icon", 10);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("spinner", ctx_r5.loading);
    i0.ɵɵproperty("id", !ctx_r5.loading ? "primary" : "")("disabled", ctx_r5.loading ? ctx_r5.loading : ctx_r5.disabled);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r5.iconName);
} }
function ButtonComponent_a_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r6.disabled)("href", ctx_r6.href, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r6.label);
} }
function ButtonComponent_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 13);
    i0.ɵɵlistener("click", function ButtonComponent_button_8_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(); return ctx_r22.disabled ? $event.stopPropagation() : ctx_r22.loading ? $event.stopPropagation() : ctx_r22.onButtonClick(); });
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "mat-icon", 10);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("spinner", ctx_r7.loading);
    i0.ɵɵproperty("disabled", ctx_r7.loading ? ctx_r7.loading : ctx_r7.disabled);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r7.iconRight && ctx_r7.label, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r7.iconName);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r7.iconLeft && ctx_r7.label, "");
} }
function ButtonComponent_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵlistener("click", function ButtonComponent_button_9_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r25); const ctx_r24 = i0.ɵɵnextContext(); return ctx_r24.disabled ? $event.stopPropagation() : ctx_r24.loading ? $event.stopPropagation() : ctx_r24.onButtonClick(); });
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "mat-icon", 10);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("spinner", ctx_r8.loading);
    i0.ɵɵproperty("disabled", ctx_r8.loading ? ctx_r8.loading : ctx_r8.disabled);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r8.iconRight && ctx_r8.label, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r8.iconName);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r8.iconLeft && ctx_r8.label, "");
} }
function ButtonComponent_button_10_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵlistener("click", function ButtonComponent_button_10_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(); return ctx_r26.disabled ? $event.stopPropagation() : ctx_r26.loading ? $event.stopPropagation() : ctx_r26.onButtonClick(); });
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "mat-icon", 10);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("spinner", ctx_r9.loading);
    i0.ɵɵproperty("disabled", ctx_r9.loading ? ctx_r9.loading : ctx_r9.disabled);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r9.iconRight && ctx_r9.label, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r9.iconName);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r9.iconLeft && ctx_r9.label, "");
} }
class ButtonComponent {
    constructor() {
        this.onClick = new EventEmitter();
    }
    ngOnInit() {
    }
    onButtonClick() {
        this.onClick.emit();
    }
}
ButtonComponent.ɵfac = function ButtonComponent_Factory(t) { return new (t || ButtonComponent)(); };
ButtonComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ButtonComponent, selectors: [["srhk-button"]], inputs: { type: "type", loading: "loading", label: "label", disabled: "disabled", href: "href", iconName: "iconName", iconRight: "iconRight", iconLeft: "iconLeft" }, outputs: { onClick: "onClick" }, decls: 11, vars: 11, consts: [[3, "ngSwitch"], ["mat-raised-button", "", 3, "spinner", "id", "disabled", "click", 4, "ngSwitchCase"], ["mat-raised-button", "", "color", "warn", 3, "spinner", "disabled", "click", 4, "ngSwitchCase"], ["mat-icon-button", "", 3, "spinner", "id", "disabled", "click", 4, "ngSwitchCase"], ["mat-stroked-button", "", "target", "_blank", 3, "disabled", "href", 4, "ngSwitchCase"], ["mat-raised-button", "", "color", "error", "style", "display: inline;", 3, "spinner", "disabled", "click", 4, "ngSwitchCase"], ["color", "primary", "mat-raised-button", "", 3, "spinner", "disabled", "click", 4, "ngSwitchCase"], ["color", "secondary", "mat-raised-button", "", 3, "spinner", "disabled", "click", 4, "ngSwitchCase"], ["mat-raised-button", "", 3, "id", "disabled", "click"], ["mat-raised-button", "", "color", "warn", 3, "disabled", "click"], [1, "srhk-button-icon"], ["mat-icon-button", "", 3, "id", "disabled", "click"], ["mat-stroked-button", "", "target", "_blank", 3, "disabled", "href"], ["mat-raised-button", "", "color", "error", 2, "display", "inline", 3, "disabled", "click"], ["color", "primary", "mat-raised-button", "", 3, "disabled", "click"], ["color", "secondary", "mat-raised-button", "", 3, "disabled", "click"]], template: function ButtonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementContainerStart(0, 0);
        i0.ɵɵtemplate(1, ButtonComponent_button_1_Template, 2, 5, "button", 1);
        i0.ɵɵtemplate(2, ButtonComponent_button_2_Template, 2, 5, "button", 1);
        i0.ɵɵtemplate(3, ButtonComponent_button_3_Template, 2, 5, "button", 1);
        i0.ɵɵtemplate(4, ButtonComponent_button_4_Template, 2, 4, "button", 2);
        i0.ɵɵtemplate(5, ButtonComponent_button_5_Template, 5, 7, "button", 1);
        i0.ɵɵtemplate(6, ButtonComponent_button_6_Template, 3, 5, "button", 3);
        i0.ɵɵtemplate(7, ButtonComponent_a_7_Template, 2, 3, "a", 4);
        i0.ɵɵtemplate(8, ButtonComponent_button_8_Template, 5, 6, "button", 5);
        i0.ɵɵtemplate(9, ButtonComponent_button_9_Template, 5, 6, "button", 6);
        i0.ɵɵtemplate(10, ButtonComponent_button_10_Template, 5, 6, "button", 7);
        i0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngSwitch", ctx.type);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", "primary");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", "secondary");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", "disabled");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", "warn");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", "iconButton");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", "iconOnly");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", "link");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", "error");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", "primary-btn");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", "secondary-btn");
    } }, directives: [i1.NgSwitch, i1.NgSwitchCase, i2.MatButton, i3.MatIcon, i2.MatAnchor], styles: ["#primary[_ngcontent-%COMP%]{background-color:#194a82;color:#fff;outline:none}#secondary[_ngcontent-%COMP%]{background-color:#f0f8ff;color:#000;outline:none}.srhk-button-icon[_ngcontent-%COMP%]{margin-bottom:4px}@keyframes spinner{to{transform:rotate(360deg)}}.spinner[_ngcontent-%COMP%]:before{content:\"\";box-sizing:border-box;position:absolute;top:50%;left:50%;width:20px;height:20px;margin-top:-10px;margin-left:-10px;border-radius:50%;border:2px solid #ffffff;border-top-color:#000;animation:spinner .8s linear infinite}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonComponent, [{
        type: Component,
        args: [{ selector: 'srhk-button', template: "<ng-container [ngSwitch]='type'>\n    <button *ngSwitchCase=\"'primary'\" [class.spinner]=\"loading\" [id]=\"!loading ? 'primary' : ''\" mat-raised-button [disabled]=\"loading ? loading : disabled\" (click)=\"disabled ? $event.stopPropagation() : loading ? $event.stopPropagation() : onButtonClick()\">{{ label }}</button>\n    <button *ngSwitchCase=\"'secondary'\" [class.spinner]=\"loading\" [id]=\"!loading ? 'secondary' : ''\" mat-raised-button [disabled]=\"loading ? loading : disabled\" (click)=\"disabled ? $event.stopPropagation() : loading ? $event.stopPropagation() : onButtonClick()\">{{ label }}</button>\n    <button *ngSwitchCase=\"'disabled'\" [class.spinner]=\"loading\" [id]=\"!disabled ? 'primary' : ''\" mat-raised-button [disabled]=\"disabled\" (click)=\"disabled ? $event.stopPropagation() : loading ? $event.stopPropagation() : onButtonClick()\">{{ label }}</button>\n    <button *ngSwitchCase=\"'warn'\" [class.spinner]=\"loading\" mat-raised-button [disabled]=\"loading ? loading : disabled\" color='warn' (click)=\"disabled ? $event.stopPropagation() : loading ? $event.stopPropagation() : onButtonClick()\">{{ label }}</button>\n    <button *ngSwitchCase=\"'iconButton'\" [class.spinner]=\"loading\" [id]=\"!loading ? 'primary' : ''\" mat-raised-button [disabled]=\"loading ? loading : disabled\" (click)=\"disabled ? $event.stopPropagation() : loading ? $event.stopPropagation() : onButtonClick()\">{{ iconRight && label }} <mat-icon class=\"srhk-button-icon\">{{ iconName }}</mat-icon> {{ iconLeft && label }}</button>\n    <button *ngSwitchCase=\"'iconOnly'\" [class.spinner]=\"loading\" [id]=\"!loading ? 'primary' : ''\" mat-icon-button [disabled]=\"loading ? loading : disabled\" (click)=\"disabled ? $event.stopPropagation() : loading ? $event.stopPropagation() : onButtonClick()\"><mat-icon class=\"srhk-button-icon\">{{ iconName }}</mat-icon></button>\n    <a *ngSwitchCase=\"'link'\" mat-stroked-button [disabled]=\"disabled\" [href]=\"href\" target=\"_blank\">{{label}}</a>\n    <button *ngSwitchCase=\"'error'\" [class.spinner]=\"loading\" mat-raised-button [disabled]=\"loading ? loading : disabled\" color='error' (click)=\"disabled ? $event.stopPropagation() : loading ? $event.stopPropagation() : onButtonClick()\" style=\"display: inline;\">{{ iconRight && label }} <mat-icon class=\"srhk-button-icon\">{{ iconName }}</mat-icon> {{ iconLeft && label }}</button>\n    <button *ngSwitchCase=\"'primary-btn'\" [class.spinner]=\"loading\" color=\"primary\" mat-raised-button [disabled]=\"loading ? loading : disabled\" (click)=\"disabled ? $event.stopPropagation() : loading ? $event.stopPropagation() : onButtonClick()\">{{ iconRight && label }} <mat-icon class=\"srhk-button-icon\">{{ iconName }}</mat-icon> {{ iconLeft && label }}</button>\n    <button *ngSwitchCase=\"'secondary-btn'\" [class.spinner]=\"loading\" color=\"secondary\" mat-raised-button [disabled]=\"loading ? loading : disabled\" (click)=\"disabled ? $event.stopPropagation() : loading ? $event.stopPropagation() : onButtonClick()\">{{ iconRight && label }} <mat-icon class=\"srhk-button-icon\">{{ iconName }}</mat-icon> {{ iconLeft && label }}</button>\n    \n</ng-container>", styles: ["#primary{background-color:#194a82;color:#fff;outline:none}#secondary{background-color:#f0f8ff;color:#000;outline:none}.srhk-button-icon{margin-bottom:4px}@keyframes spinner{to{transform:rotate(360deg)}}.spinner:before{content:\"\";box-sizing:border-box;position:absolute;top:50%;left:50%;width:20px;height:20px;margin-top:-10px;margin-left:-10px;border-radius:50%;border:2px solid #ffffff;border-top-color:#000;animation:spinner .8s linear infinite}\n"] }]
    }], function () { return []; }, { type: [{
            type: Input
        }], loading: [{
            type: Input
        }], label: [{
            type: Input
        }], disabled: [{
            type: Input
        }], href: [{
            type: Input
        }], iconName: [{
            type: Input
        }], iconRight: [{
            type: Input
        }], iconLeft: [{
            type: Input
        }], onClick: [{
            type: Output
        }] }); })();

class SrhkCoreLibraryModule {
}
SrhkCoreLibraryModule.ɵfac = function SrhkCoreLibraryModule_Factory(t) { return new (t || SrhkCoreLibraryModule)(); };
SrhkCoreLibraryModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SrhkCoreLibraryModule, bootstrap: [SrhkCoreLibraryComponent,
        ButtonComponent] });
SrhkCoreLibraryModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            MatFormFieldModule,
            MatInputModule,
            MatIconModule,
            MatDialogModule,
            MatButtonModule,
            MatIconModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SrhkCoreLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    SrhkCoreLibraryComponent,
                    ButtonComponent
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    MatFormFieldModule,
                    MatInputModule,
                    MatIconModule,
                    MatDialogModule,
                    MatButtonModule,
                    MatIconModule
                ],
                exports: [
                    SrhkCoreLibraryComponent,
                    ButtonComponent
                ],
                bootstrap: [SrhkCoreLibraryComponent,
                    ButtonComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SrhkCoreLibraryModule, { declarations: [SrhkCoreLibraryComponent,
        ButtonComponent], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule], exports: [SrhkCoreLibraryComponent,
        ButtonComponent] }); })();

class CommonCacheService {
    constructor() {
        this.cache = {
            codeValues: {},
            countryTypes: {},
            pincodeDivisions: {},
            doctors: {},
            taxCategories: {},
            loggedInUserInfo: {},
            serviceList: {},
            clientSettings: {},
            departments: {},
            suppliers: {},
            insuranceClients: {},
            creditClients: {},
            codeValueDomains: {},
            allTaxCategories: {},
        };
    }
}
CommonCacheService.ɵfac = function CommonCacheService_Factory(t) { return new (t || CommonCacheService)(); };
CommonCacheService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CommonCacheService, factory: CommonCacheService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CommonCacheService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

const ACCESS_TOKEN = 'access_token';
const REFRESH_TOKEN = 'refresh_token';
const USER_INFO = 'user_info';
const IS_AUTHENTICATED = 'isAuthenticated';
const UA_COSTCENTER = 'ua_costcenter';
const UA_ORG = 'ua_org';
const HOME_DASHBOARD_URL = 'home_dashboard_url';
const APP_ID = 'app_id';
const SHOW_ON_LOAD_SPINNER = 'show_on_load_spinner';
const IS_FROM_DONATION = 'is_from_Donation';
const DONATION_PURPOSE = 'donation_purpose';
class TokenService {
    constructor() {
    }
    getShowOnloadSpinner() {
        return sessionStorage.getItem(SHOW_ON_LOAD_SPINNER) || 'true';
    }
    showOnloadSpinner(show) {
        sessionStorage.setItem(SHOW_ON_LOAD_SPINNER, show);
    }
    setIsFromDonation(isFromDonation) {
        sessionStorage.setItem(IS_FROM_DONATION, isFromDonation);
    }
    isFromDonation() {
        return sessionStorage.getItem(IS_FROM_DONATION) || 'false';
    }
    saveAppId(appId) {
        sessionStorage.setItem(APP_ID, appId);
    }
    getAppId() {
        return sessionStorage.getItem(APP_ID);
    }
    getToken() {
        return sessionStorage.getItem(ACCESS_TOKEN);
    }
    getRefreshToken() {
        return sessionStorage.getItem(REFRESH_TOKEN);
    }
    getUserInfo() {
        return JSON.parse(sessionStorage.getItem(USER_INFO) || '');
    }
    saveUserInfo(userInfo) {
        sessionStorage.setItem(USER_INFO, JSON.stringify(userInfo));
    }
    saveToken(token) {
        sessionStorage.setItem(ACCESS_TOKEN, token);
    }
    saveRefreshToken(refreshToken) {
        sessionStorage.setItem(REFRESH_TOKEN, refreshToken);
    }
    removeToken() {
        sessionStorage.removeItem(ACCESS_TOKEN);
    }
    removeRefreshToken() {
        sessionStorage.removeItem(REFRESH_TOKEN);
    }
    removeUserInfo() {
        sessionStorage.removeItem(USER_INFO);
    }
    removeIsAuthenticated() {
        sessionStorage.removeItem(IS_AUTHENTICATED);
    }
    setCostCenter(costCenter) {
        sessionStorage.setItem(UA_COSTCENTER, costCenter);
    }
    getCostCenter() {
        return sessionStorage.getItem(UA_COSTCENTER);
    }
    setImpersonatedOrganization(org) {
        sessionStorage.setItem(UA_ORG, JSON.stringify(org));
    }
    getImpersonatedOrganization() {
        return JSON.parse(sessionStorage.getItem(UA_ORG) || "{}");
    }
    setHomeDashboardURL(homeDashboardURL) {
        sessionStorage.setItem(HOME_DASHBOARD_URL, homeDashboardURL);
    }
    getHomeDashboardURL() {
        return sessionStorage.getItem(HOME_DASHBOARD_URL);
    }
    setDonationPurpose(purpose) {
        sessionStorage.setItem(DONATION_PURPOSE, purpose);
    }
    getDonationPurpose() {
        return sessionStorage.getItem(DONATION_PURPOSE);
    }
}
TokenService.ɵfac = function TokenService_Factory(t) { return new (t || TokenService)(); };
TokenService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: TokenService, factory: TokenService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TokenService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return []; }, null); })();

class ToastService {
    constructor(toastr) {
        this.toastr = toastr;
    }
    showSuccess(message, title) {
        this.toastr.success(message, title, {
            timeOut: 3000,
        });
    }
    showError(message, title) {
        this.toastr.error(message, title, {
            timeOut: 3000,
        });
    }
    showInfo(message, title) {
        this.toastr.info(message, title, {
            timeOut: 3000,
        });
    }
    showWarning(message, title) {
        this.toastr.warning(message, title, {
            timeOut: 3000,
        });
    }
}
ToastService.ɵfac = function ToastService_Factory(t) { return new (t || ToastService)(i0.ɵɵinject(i1$1.ToastrService)); };
ToastService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ToastService, factory: ToastService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToastService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1$1.ToastrService }]; }, null); })();

class AuthContext {
    constructor() {
        this._isAuthenticated = Boolean(sessionStorage.getItem('isAuthenticated'));
    }
    setAuthenticated() {
        this._isAuthenticated = true;
        sessionStorage.setItem('isAuthenticated', 'true');
    }
    removeIsAuthenticated() {
        this._isAuthenticated = false;
        sessionStorage.removeItem('isAuthenticated');
    }
    get isAuthenticated() {
        return this._isAuthenticated;
    }
}
AuthContext.ɵfac = function AuthContext_Factory(t) { return new (t || AuthContext)(); };
AuthContext.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AuthContext, factory: AuthContext.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthContext, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return []; }, null); })();

const APP_URLS = {
    getUser: '/v1/user/{userRoleId}',
    oauthToken: '/api/v1/user/signIn',
    oauthSignup: '/api/v1/user/signUp',
    loggedInUser: '/api/v1/user/loggedInUser',
    forget_password: ''
};

class HttpService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    get(endPoint, headers, params = new HttpParams(), observe, responseType) {
        return this.httpClient
            .get(`/${endPoint}`, {
            headers,
            params: this.buildParams(params),
            observe,
            responseType,
        })
            .pipe(catchError(this.handleError));
    }
    put(endPoint, payload, headers, params = new HttpParams(), observe, responseType) {
        return this.httpClient.put(`/${endPoint}`, JSON.stringify(payload), {
            headers,
            params: this.buildParams(params),
            observe,
            responseType,
        });
    }
    post(endPoint, payload, headers, params = new HttpParams(), observe, responseType) {
        return this.httpClient.post(`/${endPoint}`, JSON.stringify(payload), {
            headers,
            params: this.buildParams(params),
            observe,
            responseType,
        });
    }
    delete(endPoint, headers, params = new HttpParams()) {
        return this.httpClient.delete(`/${endPoint}`, {
            headers,
            params: this.buildParams(params),
        });
    }
    buildParams(params) {
        let newParams = new HttpParams().set('apikey', '45af497cd');
        if (params !== null) {
            params.keys().forEach((key) => {
                newParams = newParams.append(key, params.get(key) || '');
            });
        }
        return newParams;
    }
    handleError(error) {
        if (error.status === 0) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error);
        }
        else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong.
            console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
        }
        // Return an observable with a user-facing error message.
        return throwError(error.error.Error);
    }
}
HttpService.ɵfac = function HttpService_Factory(t) { return new (t || HttpService)(i0.ɵɵinject(i1$2.HttpClient)); };
HttpService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: HttpService, factory: HttpService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HttpService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1$2.HttpClient }]; }, null); })();

const OAUTH_CLIENT = 'srhk-base-service';
const headers = new HttpHeaders({
    'Content-Type': 'application/json',
});
class AuthService {
    constructor(http, httpService, tokenService, authContext, commonCacheService) {
        this.http = http;
        this.httpService = httpService;
        this.tokenService = tokenService;
        this.authContext = authContext;
        this.commonCacheService = commonCacheService;
        this.redirectUrl = '';
        this.clientSecret = '';
        this.clientSecret = window?.__env?.CLINET_SECRET;
    }
    static handleError(error) {
        if (error.error instanceof ErrorEvent) {
            console.error('An error occurred:', error.error.message);
        }
        else {
            console.error(`Backend returned code ${error.status}, body was: ${error.error}`);
        }
        return throwError('Something bad happened; please try again later.');
    }
    static log(message) {
        // console.log(message);
    }
    getAccessToken(username, password) {
        const userInfo = { userId: username, password };
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json; charset=UTF-8',
                'App-ID': this.tokenService.getAppId() || ""
            }),
        };
        const http$ = this.http.post(APP_URLS.oauthToken, userInfo, options);
        return new Promise((resolve, _reject) => {
            http$.subscribe(res => { resolve(res); }, err => { resolve(err); }, () => console.log('HTTP request completed.'));
        });
    }
    getUserInfo(access_token) {
        const headers = {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + access_token,
                'App-ID': this.tokenService.getAppId() || "",
            })
        };
        const http$ = this.http.get(APP_URLS.loggedInUser, headers);
        return new Promise((resolve, _reject) => {
            http$.subscribe(res => { resolve(res); }, err => { resolve(err); }, () => console.log('HTTP request completed.'));
        });
    }
    getUserData(access_token, appId = "CUSTOMER") {
        const headers = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'App-ID': appId,
                'Authorization': 'Bearer ' + access_token
            })
        };
        const http$ = this.http.get(APP_URLS.oauthToken, headers);
        return new Promise((resolve, _reject) => {
            http$.subscribe(res => { resolve(res); }, err => { resolve(err); }, () => console.log('HTTP request completed.'));
        });
    }
    refreshToken(refreshData, appId = "CUSTOMER") {
        this.tokenService.removeToken();
        this.tokenService.removeRefreshToken();
        const body = new HttpParams()
            .set('refresh_token', refreshData.refresh_token)
            .set('grant_type', 'refresh_token');
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json; charset=UTF-8',
                Authorization: 'Basic ' + btoa(OAUTH_CLIENT + ':' + this.clientSecret),
                observe: 'response',
                'App-ID': appId,
            }),
        };
        return this.http.post(APP_URLS.oauthToken, body, options)
            .pipe(tap(res => {
            this.tokenService.saveToken(res.access_token);
            this.tokenService.saveRefreshToken(res.refresh_token);
        }), catchError(AuthService.handleError));
    }
    logout() {
        // TODO: call the logout service
        this.tokenService.removeToken();
        this.tokenService.removeRefreshToken();
        this.tokenService.removeUserInfo();
        this.authContext.removeIsAuthenticated();
    }
    register(data) {
        return this.httpService.post(APP_URLS.oauthSignup, data, headers)
            .pipe(tap(_ => AuthService.log('register')), catchError(AuthService.handleError));
    }
    secured() {
        return this.httpService.get('secret', headers)
            .pipe(catchError(AuthService.handleError));
    }
}
AuthService.ɵfac = function AuthService_Factory(t) { return new (t || AuthService)(i0.ɵɵinject(i1$2.HttpClient), i0.ɵɵinject(HttpService), i0.ɵɵinject(TokenService), i0.ɵɵinject(AuthContext), i0.ɵɵinject(CommonCacheService)); };
AuthService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AuthService, factory: AuthService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: i1$2.HttpClient }, { type: HttpService }, { type: TokenService }, { type: AuthContext }, { type: CommonCacheService }]; }, null); })();

class DataShareService {
    constructor() {
        this.sharingData = new Subject();
    }
}
DataShareService.ɵfac = function DataShareService_Factory(t) { return new (t || DataShareService)(); };
DataShareService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DataShareService, factory: DataShareService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DataShareService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class AuthInterceptor {
    constructor(http, router, tokenService, authService, dataShareService) {
        this.http = http;
        this.router = router;
        this.tokenService = tokenService;
        this.authService = authService;
        this.dataShareService = dataShareService;
        this.refreshTokenInProgress = false;
        this.tokenRefreshedSource = new Subject();
        this.tokenRefreshed$ = this.tokenRefreshedSource.asObservable();
    }
    addAuthHeader(request) {
        const token = this.tokenService.getToken();
        const appId = this.tokenService.getAppId();
        const costCenter = this.tokenService.getCostCenter();
        const impersonatedOrganization = this.tokenService.getImpersonatedOrganization();
        if (token && !request.headers.has('Authorization')) {
            request = request.clone({
                setHeaders: {
                    Authorization: 'Bearer ' + token,
                },
            });
        }
        if (!(request.body instanceof FormData) && !request.headers.has('Content-Type')) {
            request = request.clone({
                setHeaders: {
                    'content-type': 'application/json',
                },
            });
        }
        request = request.clone({
            headers: request.headers.set('Accept', 'application/json'),
        });
        request = request.clone({
            headers: request.headers.set('App-ID', appId ? appId : ''),
        });
        request = request.clone({
            headers: request.headers.set('ua-costcenter', costCenter ? costCenter : ''),
        });
        request = request.clone({
            headers: request.headers.set('ua-coid', (impersonatedOrganization && impersonatedOrganization.coid) ? impersonatedOrganization.coid : ''),
        });
        request = request.clone({
            headers: request.headers.set('ua-org-name', (impersonatedOrganization && impersonatedOrganization.name) ? impersonatedOrganization.name : ''),
        });
        request = request.clone({
            headers: request.headers.set('ua-product', (impersonatedOrganization && impersonatedOrganization.product) ? impersonatedOrganization.product : ''),
        });
        request = request.clone({
            headers: request.headers.set('ua-org-code', (impersonatedOrganization && impersonatedOrganization.organizationCode) ? impersonatedOrganization.organizationCode : ''),
        });
        return request;
    }
    intercept(request, next) {
        request = this.addAuthHeader(request);
        console.log('Auth Interceptor Request', request); // TODO: Needs to Remove after fixing sticky session
        return next.handle(request).pipe(filter(event => event instanceof HttpResponse), catchError(error => {
            return this.handleResponseError(error, request, next);
        }));
    }
    refreshToken() {
        const refreshToken = this.tokenService.getRefreshToken();
        if (this.refreshTokenInProgress) {
            return new Observable(observer => {
                this.tokenRefreshed$.subscribe(() => {
                    observer.next();
                    observer.complete();
                });
            });
        }
        else {
            this.refreshTokenInProgress = true;
            return this.authService.refreshToken({ refresh_token: refreshToken }).pipe(tap(() => {
                this.refreshTokenInProgress = false;
                this.tokenRefreshedSource.subscribe({
                    next: (v) => v
                });
            }));
        }
    }
    logout() {
        // this.authService.logout();
        window.sessionStorage.clear();
        window.location.reload();
        this.router.navigate(['home']);
    }
    handleResponseError(error, request, next) {
        this.dataShareService.sharingData.next(error);
        // Business error
        if (error.status === 400) {
            // Show message
        }
        else if (error.status === 401) {
            if ("invalid_grant" == error?.error?.error) {
                window.sessionStorage.clear();
            }
            else {
                this.logout();
            }
        }
        else if (error.status === 403) {
            // Show message
            // Logout
            const token = this.tokenService.getToken();
            this.fetchUserInfo(token);
            //this.logout();
        }
        else if (error.status === 500) {
            // Show message
        }
        else if (error.status === 503) {
            // Show message
            // Redirect to the maintenance page
        }
        else if (error.status === 0) {
            this.logout();
        }
        console.error(error);
        return throwError(error);
    }
    fetchUserInfo(access_token) {
        const headers = {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + access_token
            })
        };
        this.http.get(APP_URLS.getUser, headers).subscribe(res => {
            console.info('User Info Called SuccessFul After 403');
        }, error => {
            console.info('User Info Called' + error);
            this.logout();
        });
    }
}
AuthInterceptor.ɵfac = function AuthInterceptor_Factory(t) { return new (t || AuthInterceptor)(i0.ɵɵinject(i1$2.HttpClient), i0.ɵɵinject(i2$1.Router), i0.ɵɵinject(TokenService), i0.ɵɵinject(AuthService), i0.ɵɵinject(DataShareService)); };
AuthInterceptor.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AuthInterceptor, factory: AuthInterceptor.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthInterceptor, [{
        type: Injectable
    }], function () { return [{ type: i1$2.HttpClient }, { type: i2$1.Router }, { type: TokenService }, { type: AuthService }, { type: DataShareService }]; }, null); })();

class ErrorHandlingService {
    constructor() {
    }
    /* preSaveValidation(formName: string, formControl: FormControl, error) {
 
     }*/
    postSaveValidation(formGroup, error) {
        let errorModel = {};
        let fieldErrorMessages = [];
        let bussinessErrorMessages = [];
        let otherErrorMessages = [];
        if (error?.error?.userMessages) {
            error?.error?.userMessages.forEach((userMessage) => {
                if (userMessage.action === 'Method Argument Not Valid') {
                    let errorMessage = {};
                    if (userMessage.field) {
                        formGroup.controls[userMessage.field].setErrors({ fieldError: { userMessage: userMessage.messageTxt } });
                        errorMessage.code = userMessage.codeValue;
                        errorMessage.message = userMessage.messageTxt;
                        fieldErrorMessages.push(errorMessage);
                    }
                }
                else if (userMessage.action === 'Data Integrity Violation at Database' ||
                    userMessage.action === 'Business Validation Error') {
                    let errorMessage = {};
                    errorMessage.code = userMessage.codeValue;
                    errorMessage.message = userMessage.messageTxt;
                    bussinessErrorMessages.push(errorMessage);
                }
                else {
                    let errorMessage = {};
                    errorMessage.code = userMessage.codeValue;
                    errorMessage.message = userMessage.messageTxt;
                    otherErrorMessages.push(errorMessage);
                }
            });
            errorModel.OtherErrors = otherErrorMessages;
            errorModel.bussinessErrors = bussinessErrorMessages;
            errorModel.fieldErrors = fieldErrorMessages;
            errorModel.formGroup = formGroup;
        }
        else {
            var errorMessage = {};
            errorMessage.message = error.messageTxt;
            otherErrorMessages.push(errorMessage);
            errorModel.OtherErrors = otherErrorMessages;
        }
        return errorModel;
    }
}
ErrorHandlingService.ɵfac = function ErrorHandlingService_Factory(t) { return new (t || ErrorHandlingService)(); };
ErrorHandlingService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ErrorHandlingService, factory: ErrorHandlingService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ErrorHandlingService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return []; }, null); })();

/*
 * Public API Surface of srhk-core-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AuthContext, AuthInterceptor, AuthService, ButtonComponent, CommonCacheService, DataShareService, ErrorHandlingService, HttpService, SrhkCoreLibraryComponent, SrhkCoreLibraryModule, SrhkCoreLibraryService, ToastService, TokenService };
